import { Box, Separator } from "@chakra-ui/react";
import SimpleIntro from "@/components/simpleIntro";
import { INTRO_CONSTANTS } from "./constants";

const IntroComponent = () => {
  return (
    <Box>
      <SimpleIntro {...INTRO_CONSTANTS} />
      <Separator borderWidth="2px" borderColor="#ECECEC" my={10} />
    </Box>
  );
};

export default IntroComponent;
